import axios from 'axios';
import downloadjs from 'downloadjs';

import configs from 'configs';

const fetch = (options) => {
  const { method = 'get', data } = options;
  let url = options.absUrl || options.url;
  if (!url.startsWith('http')) {
    url = configs.authApiUrl + url;
  }

  switch (method.toLowerCase()) {
    case 'get':
      return axios.get(url, {
        params: data,
      });
    case 'delete':
      return axios.delete(url, {
        data,
      });
    case 'post':
      return axios.post(url, data);
    case 'put':
      return axios.put(url, data);
    case 'patch':
      return axios.patch(url, data);
    default:
      return axios(options);
  }
};

export default function request({ download, ...options }) {
  return fetch(options).then((response) => {
    const { statusText, status } = response;

    let data = response.data;
    if (download) {
      let fileName = download;
      if (response.headers['content-disposition']) {
        fileName = response.headers['content-disposition'].replace('attachment; filename=', '');
      }
      if (download.endsWith('.csv')) {
        data = new Blob([data], { type: 'text/csv;charset=utf-8' });
      }
      downloadjs(data, fileName);
      data = {};
    }

    if (data instanceof Array) {
      data = {
        list: data,
      };
    }

    return {
      success: true,
      message: statusText,
      statusCode: status,
      ...data,
    };
  }).catch((error) => {
    const { response } = error;
    const ret = { success: false };
    if (response && response instanceof Object) {
      ret.statusCode = response.status;
      const { data, statusText } = response;
      console.log('response', response);
      if (data) {
        if (data.error) {
          // Error format from auth api result: {error: {code, message}}
          ret.message = data.error.message;
          ret.errorCode = data.error.code;
        } else {
          // Error format from accounting api result: {error_message, error_code, error_data}
          ret.message = data.error_message;
          ret.errorCode = data.error_code;
          ret.errorData = data.error_data;
        }
      }
      if (!ret.message) ret.message = statusText;
    } else {
      ret.statusCode = 600;
      ret.message = error.message || 'Lỗi kết nối mạng';
    }
    return ret;
  });
}



// WEBPACK FOOTER //
// ./src/utils/request.js